import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import Aos from 'aos';

import { PrivateRoute } from './components/PrivateRoute';
import { Header } from './common/Header';
import Footer from './common/Footer';
import { Policy } from './policy/Policy';

import { HomePage } from './home/HomePage';
import { Signin } from './user/auth/Signin';

import { NoticePage } from './board/notice/NoticePage';
import { BoardQnaPage } from './board/qna/BoardQnaPage';

import { RecommendPage } from './recommend/RecommendPage';


import { AuthorMeetingPage } from './authorMeeting/AuthorMeetingPage';
import useNotification from '../utils/hooks/useNotification';
import useInitAuthenticate from '../utils/hooks/useUserTokenChecker';
import SchoolRecommendPage from './recommend/school/SchoolRecommendPage';
import UserJoin from './user/UserJoin';
import { BookPage } from './books/BookPage';
import { BookReportPage } from './bookreport/BookReportPage';
import ReadingTestPage from './readingTest/ReadingTestPage';
import { ReadingPicturePage } from './readingPicture/ReadingPicturePage';
import { ReadingPhotoPage } from './readingPhoto/ReadingPhotoPage';
import { VideoPage } from './videoreport/VideoPage';
import { UserBookPage } from './userBook/UserBookPage';
import { DonghwaPage } from './donghwa/DonghwaPage';
import { DebateTopicList } from './debate/topic/DebateTopicList';
import UserPage from './user/UserPage';
import { useSelector } from 'react-redux';
import UserStanBy from './user/UserStanBy';
import { useSchoolChecker } from 'utils/hooks/useSchoolChecker';
import { Error403 } from './errors/error403';
import { ErrorPaste } from './errors/ErrorPaste';
import { UserWarning } from './warning/UserWarning';
import { NotificationModal } from './notification/NotificationModal';
import { SchoolConfirmation } from './common/SchoolConfirmation';

export const SchoolApp = () => {
    useSchoolChecker();
    const school = useSelector(state => state.school);
    const auth = useSelector(state => state.auth);
    useInitAuthenticate();
    useNotification();

    useEffect(() => {
        Aos.init();
    }, []);


    if (school.code === null) return null;
    if (auth.authenticated) {
        if (auth.restricted) return <UserWarning />;
        if (auth.isStanBy === 'Y' || auth.isStanBy === undefined) return <UserStanBy />;
    }

    return (
        <div id="wrap">
            <Header />
            <div id="container">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/meeting/*" element={<AuthorMeetingPage />} />
                    <Route path="/recommend" element={<RecommendPage />} />
                    <Route path="/recommend/school" element={<SchoolRecommendPage />} />
                    <Route path="/donghwa/*" element={<DonghwaPage />} />
                    <Route path="/reading/test/*" element={<ReadingTestPage />} />

                    <Route path="/book/*" element={<BookPage />} />

                    <Route path="/debate/*" element={<DebateTopicList />} />

                    <Route path="/bookreport/*" element={<BookReportPage />} />
                    <Route path="/picture/*" element={<ReadingPicturePage />} />
                    <Route path="/photo/*" element={<ReadingPhotoPage />} />
                    <Route path="/video/*" element={<VideoPage />} />
                    <Route path="/userbook/*" element={<UserBookPage />} />

                    <Route path="/user/*" element={<PrivateRoute><UserPage /></PrivateRoute>} />

                    <Route path="/notice/*" element={<NoticePage />} />
                    <Route path="/board/qna/*" element={<BoardQnaPage />} />

                    <Route path="/join/*" element={<UserJoin />} />
                    <Route path="/signin/*" element={<Signin />} />
                    <Route path="/policy/:type" element={<Policy />} />

                    <Route path="/error403" element={<Error403 />} />
                    <Route path="/errorPaste" element={<ErrorPaste />} />
                </Routes>
            </div>
            {/* 
                번들용량이 생각보다 적은데 굳이 필요할까? 
            <Suspense fallback={<LazyLoading />}>
                <Routes>
                    
                </Routes>
            </Suspense> */}
            <Footer />
            <NotificationModal />
            <SchoolConfirmation />
        </div>
    );
}